import Vue from 'vue'
let lastSrcs;       // 上次获取到的Script地址


// 正则获取js地址
const scriptReg = /<script.*?(?:>|>)/gi
const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i

/**
 * 获取最新的script链接
 */
async function extractNewScripts() {
    const html = await fetch('/?_time=' + Date.now()).then(res => res.text())
    let arr = html.match(scriptReg)
    let resupt = []
    for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg)
        resupt.push(src[1])
    }
    return resupt
}


/**
 * 检查是否需要更新
 */
export async function needUpdate() {
    const newScript = await extractNewScripts()
    if (!lastSrcs) {
        lastSrcs = newScript
        return false
    }
    let result = false
    if (lastSrcs.length !== newScript.length) {
        result = true
    }
    for (let i = 0; i < lastSrcs.length; i++) {
        if (lastSrcs[i] !== newScript[i]) {
            result = true
            break
        }
    }
    lastSrcs = newScript
    return result
}


/**
 * 设置时间
 */
export function Hotupdate(that) {
    setTimeout(async () => {
        const willupdate = await needUpdate()
        if (willupdate) {
            updateTip(that)
        }
        Hotupdate(that)
    }, 1000 * 600)
}

/**
 * 打开更新提示
 */
let closeNotify = {
    close: () => { }
}
export function updateTip(that) {
    closeNotify.close()
    closeNotify = that.$notify({
        title: '系统更新提示',
        duration: 10000,
        dangerouslyUseHTMLString: true,
        message: `
        <p>尊敬的用户您好，系统更新啦！</p>
        <p style="margin-top:6px;display:flex;">按<kbd class="ctrl">Ctrl</kbd>+<kbd>F5</kbd>进行更新哦🥰</p>
        <p style="margin-top:6px; color:red;">温馨提示：如果您正在操作表格，请操作完后在更新哦！</p>
        `
    });
}


// WEBPACK FOOTER //
// ./src/utils/updeteServe.js